module.exports = __webpack_public_path__ + "static/img/Proton.2909698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Proton.jpg
// module id = h3dl
// module chunks = 0